import { render } from "./LeaveForm.vue?vue&type=template&id=b2357770&scoped=true"
import script from "./LeaveForm.vue?vue&type=script&lang=js"
export * from "./LeaveForm.vue?vue&type=script&lang=js"

import "./LeaveForm.vue?vue&type=style&index=0&id=b2357770&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2357770"]])

export default __exports__